// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_6vb","cls2":"Comments-cls2_MJ- Comments-cls1_6vb"};